// extracted by mini-css-extract-plugin
export var fullGrid = "_2l-3";
export var pdpPreviewContainer = "_2l-1";
export var previewContainer = "_2l-0";
export var togglePreviewContainer = "_2l-2";